import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import {
  computeBtnTaraticClasses,
  type BtnTaraticColor,
  type BtnTaraticSize,
} from '../../contracts/uiContracts';

export interface BtnTaraticProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  color?: BtnTaraticColor;
  size?: BtnTaraticSize;
  iconOnly?: boolean;
  loading?: boolean;
  className?: string;
}

export default function BtnTaratic({
  children,
  color = 'ghost-dark',
  size = 'sm',
  iconOnly = false,
  loading = false,
  disabled,
  className = '',
  ...props
}: BtnTaraticProps) {
  const buttonClassName = computeBtnTaraticClasses({ color, size, iconOnly, className });

  return (
    <button
      className={buttonClassName}
      disabled={disabled || loading}
      aria-busy={loading ? 'true' : undefined}
      {...props}
    >
      {loading && (
        <FontAwesomeIcon
          icon={faSpinner}
          className={`animate-spin ${iconOnly ? '' : 'mr-2'}`}
        />
      )}
      {children}
    </button>
  );
}
